import { type ReactElement } from "react";
import { useAuthenticated } from "@/frontend/shared/lib/hooks/useAuthenticated";
import { useHistoricalNavigate } from "@/frontend/shared/lib/useHistoricalNavigate/useHistoricalNavigate";

type TProps = {
  children: ReactElement;
};

export function NonProtectedRoute({ children }: TProps) {
  const { navigate } = useHistoricalNavigate();
  const { data: isAuth, isLoading } = useAuthenticated();

  if (isLoading) {
    return null;
  }

  if (isAuth) {
    navigate("/");
    return null;
  }

  return <div>{children}</div>;
}
